import React from 'react';
import { InnerLayout } from '@layout';
import OrganizationList from '@components/OrganizationList';

export default function CommunityAndPolicy({
  title = 'Community And Policy',
  h1 = 'Community & Policy',
  ...restProps
}) {
  return (
    <InnerLayout
      title={title}
      h1={h1}
      {...restProps}
    >
      <OrganizationList items={organizations} />
    </InnerLayout>
  );
}

const organizations = [
  {
    name: 'No Time for Silence',
    text:
      'A Call to Action for an Anti-Racist Science Community from Geoscientists of Color: Listen, Act, Lead',
    url: 'https://notimeforsilence.org',
    logo: require('./logos/no-time-for-silence.png'),
    logoWidth: 150,
    logoOffsetTop: -6
  },
  {
    name: 'The Center for Rural Enterprise and Environmental Justice',
    text:
      'Working to address the lack of infrastructure, particularly wastewater infrastructure, necessary for sustainable economic development in rural America.',
    url: 'https://www.creej.org',
    logo: require('./logos/creej.png'),
    logoWidth: 165,
    logoOffsetTop: 5
  },
  {
    name: 'Esperanza Community Housing',
    text:
      'A social justice non-profit in South Central Los Angeles that achieves long-term, comprehensive community development.',
    url: 'https://www.esperanzacommunityhousing.org',
    logo: require('./logos/esperanza.png'),
    logoWidth: 179,
    logoOffsetTop: 10
  },
  {
    name: 'Amah Mutsun Land Trust',
    text: 'Restoring indigenous knowledge and practices to Popeloutchom',
    url: 'https://www.amahmutsunlandtrust.org',
    logo: require('./logos/amah-mutsun.png'),
    logoWidth: 135,
    logoWidthSmall: 118,
    logoOffsetTop: -8
  },
  {
    name: 'Watts Labor Community Action Committee',
    text:
      'The Watts Labor Community Action Committee (WLCAC) is a non-profit 501 (c) 3, community-based organization dedicated to improving the quality of life for South Central Los Angeles residents.',
    url: 'http://www.wlcac.org',
    logo: require('./logos/wlcac.png'),
    logoWidth: 169
  },
  {
    name: 'Geochemical Society',
    text:
      'The Geochemical Society is committed to providing an open, diverse, and supportive environment for all members of our community. Improving diversity, equity, and inclusion (DEI) in the geosciences is a key goal for the organization',
    url:
      'https://www.geochemsoc.org/about/membership/diversity-equity-and-inclusion',
    logo: require('./logos/geochemical-society.link.svg'),
    logoWidth: 200,
    logoOffsetLeft: 5
  }
];
